import { autoLcMemberCompanyInquiry } from '@/locales/ko/views/member_company_inquiry';
import { i18n } from '@/locales';
const lc = autoLcMemberCompanyInquiry();
export const tableHeader = [
    {
        title: lc('list.table.id'),
        align: 'center',
        width: 80,
    },
    {
        title: lc('list.table.target_Type'),
        align: 'center',
        width: 50,
    },
    {
        title: lc('list.table.processing_Type'),
        align: 'center',
        width: 100,
    },
    {
        title: lc('list.table.type'),
        align: 'center',
        width: 220,
    },
    {
        title: lc('list.table.title'),
        align: 'center',
    },
    {
        title: lc('list.table.created_time'),
        align: 'center',
        width: 100,
    },
];
export const enumProcessingType = {
    RECEIVED: lc('processingType.received'),
    IN_PROGRESS: lc('processingType.in_progress'),
    DONE: lc('processingType.done'),
    ALREADY_ACCEPTED_VAN: lc('processingType.already_accepted_van'),
    REJECTED: lc('processingType.rejected'),
    NO: lc('processingType.no'),
};
export const enumTargetType = {
    ALL: i18n.t('common.all'),
    DISTRIBUTOR: i18n.t('common.distributor'),
    HUB: i18n.t('common.hub'),
    STORE: lc('store'),
};
export const enumType = {
    WORK: lc('post_category.work'),
    VAN: lc('post_category.van'),
    PRODUCT: lc('post_category.product'),
    CANCEL_DUPLICATED_PAYMENT: lc('post_category.cancel_duplicated_payment'),
    POST_JOB_ADVERTISEMENT: lc('post_category.posy_job_advertisement'),
    CONNECT_POS: lc('post_category.connect_pos'),
    CHANGE_BUSINESS_NUMBER: lc('post_category.chabge_business_number'),
    VAT_REFERENCE: lc('post_category.vat_reference'),
    ENTRY_KAKAO_TALK_ORDER: lc('post_category.entry_kakao_talk_order'),
    CONNECT_BAEMIN_SERVER: lc('post_category.connrct_baemin_server'),
    BIKE_LEASE_AJ_BIKE: lc('post_category.bike_lease_aj_bike'),
    BIKE_LEASE_BIKE_MASTER: lc('post_category.bike_lease_bike_master'),
    BIKE_LEASE_BIKE_BANK: lc('post_category.bike_lease_bike_bank'),
    APPLY_ALBAMON: lc('post_category.apply_albamon'),
    CANCEL_ALBAMON: lc('post_category.cancel_albmon'),
    APPLY_ALBA_HEAVEN: lc('post_category.apply_alba_heaven'),
    CANCEL_ALBA_HEAVEN: lc('post_category.cancel_alba_heaven'),
};
export const enumProcessing = {
    RECEIVED: 'RECEIVED',
    IN_PROGRESS: 'IN_PROGRESS',
    DONE: 'DONE',
    ALREADY_ACCEPTED_VAN: 'ALREADY_ACCEPTED_VAN',
    REJECTED: 'REJECTED',
    NO: 'NO',
};
